export default __webpack_public_path__ + "static/arrow-blue-small-faa4a4e0f6a6637a5014a01f010aa857.png";